module.exports = __webpack_public_path__ + "img/square_nut.prt.c0313d7a.jpg";